import { api } from '@/lib/api';
import type { AuthenticatedUser, AuthLoginResponse } from '@/types/domain';

export const authApi = {
  login: (username: string, pin: string) =>
    api.post<AuthLoginResponse>('/auth/login', { username, pin }),
  refresh: (refreshToken?: string) =>
    api.post<AuthLoginResponse>(
      '/auth/refresh',
      refreshToken ? { refresh_token: refreshToken } : {}
    ),
  logout: (refreshToken?: string) =>
    api.post<{ success: true }>(
      '/auth/logout',
      refreshToken ? { refresh_token: refreshToken } : {}
    ),
  me: () => api.get<AuthenticatedUser>('/auth/me'),
  myCapabilities: () =>
    api.get<{ capabilities: string[] }>('/auth/me/capabilities')
};
